<template>
  <HeroSection 
    title="Le Blog"
    subtitle="Conseils, actualités, productivité et annonces de mises à jour pour mieux gérer vos projets."
    :isBig="false"
    bgImg="blog.jpg"
  />

  <!-- posts -->
  <section class="py-16 px-64 bg-white min-h-screen">
    <div class="w-full mx-auto space-y-12">
      <div
        v-for="post in posts"
        :key="post.id"
        class="bg-gray-50 rounded-lg shadow p-8"
      >
        <div class="flex items-center gap-4 mb-2">
          <span class="text-sm text-gray-500">{{ post.date }}</span>
          <span v-if="post.category" class="bg-primary text-white text-xs px-2 py-1 rounded">{{ post.category }}</span>
        </div>
        <h2 class="text-2xl font-bold mb-4">{{ post.title }}</h2>
        <div class="text-gray-700 leading-relaxed text-left" v-html="post.content"></div>
      </div>
    </div>
  </section>
</template>

<script>
import HeroSection from '@/components/Showcase/HeroSection.vue';
import { fetchblogPosts, addblogPost, deleteblogPost, updateblogPost } from '@/services/blogService';

export default {
  name: 'ShowcaseBlog',
  components: {
    HeroSection
  },
  data() {
    return {
      posts: []
    };
  },
  async mounted(){
    this.posts = await fetchblogPosts();
  }
};
</script>